import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { useEmployerUserContactQuery } from '@restworld/feature-authentication';
import { LinkComponentType, MainContext, NavigationContextProvider } from '@restworld/utils-common';

import ContactRestworldManagerModal from './contact-restworld-manager-modal';
// import CollaboratorWelcomeModal from './collaborator-welcome-modal';

const MainContent = ({ children }: { children: ReactNode }) => {
  useEmployerUserContactQuery();
  return (
    <>
      {children}
      <ContactRestworldManagerModal />
      {/* <CollaboratorWelcomeModal /> */}
    </>
  );
};

export const MainContextWrapper = ({ children }: { children: React.ReactNode }) => (
  <NavigationProviderWrapper>
    <MainContext>
      <MainContent>{children}</MainContent>
    </MainContext>
  </NavigationProviderWrapper>
);
const NavigationProviderWrapper = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  return (
    <NavigationContextProvider linkComponent={Link as LinkComponentType} router={router}>
      {children}
    </NavigationContextProvider>
  );
};
